<!-- Header that allows for selecting the Infrastructure subpage to be on -->
<app-infrastructure-header [title]='"RFID ENCODING SCHEMES"'></app-infrastructure-header>

<!-- Main Screen which shows the Rfid Encoding Scheme Objects and Rfid Encoding Scheme Instances -->
<div style="clear: both" id="objectContentPane">
	<div style="margin: 12px">

		<!-- Tab Navigation Control -->
		<ul class="nav nav-tabs">
			<li class="active"><a data-toggle="tab" href="#rfid-encoding-scheme-instances-tab" aria-expanded="true"><i class="fa fa-star-o"></i> ENCODINGS</a></li>
			<li class=""><a data-toggle="tab" href="#rfid-encoding-scheme-objects-tab" aria-expanded="false"><i class="fa fa-star-o"></i> ENCODING TYPES</a></li>
		</ul>

		<!-- Tab Content -->
		<div class="tab-content">

			<!-- Rfid Encoding Scheme Objects Tab -->
			<div id="rfid-encoding-scheme-objects-tab" class="tab-pane fade">

				<!-- "Add Encoding Type" Button -->
				<button (click)="addRfidEncodingSchemeClicked()" type="button" class="btn btn-ef"><em
						class="fa fa-plus"></em> ADD ENCODING TYPE
				</button>

				<!-- "Options" Button w/ drop down options-->
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-th"></em> OPTIONS <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<li (click)="editSelectedRfidEncodingSchemeClicked()"
							[class.disabled]="!isSingleRfidEncodingSchemeObjectSelected()"><a><em
									class="fa fa-pencil"></em> EDIT</a></li>
						<li (click)="duplicateSelectedRfidEncodingSchemeClicked()"
							[class.disabled]="!isSingleRfidEncodingSchemeObjectSelected()"><a><em
									class="fa fa-clone"></em> DUPLICATE</a></li>
						<li (click)="deleteSelectedRfidEncodingSchemesClicked()"
							[class.disabled]="!isAnyRfidEncodingSchemeObjectsSelected()"><a><em
									class="fa fa-remove"></em> DELETE</a></li>
						<li class="divider"></li>
						<li (click)="addSelectedRfidEncodingSchemeObjectsToGroupClicked()"
							[class.disabled]="!isAnyRfidEncodingSchemeObjectsSelected()"><a><em class="fa fa-plus"></em>
								ADD TO GROUP</a></li>
						<li (click)="removeSelectedRfidEncodingSchemeObjectsFromGroupClicked()"
							[class.disabled]="!isAnyRfidEncodingSchemeObjectsSelected()"><a><em
									class="fa fa-remove"></em> REMOVE FROM GROUP</a></li>
						<li (click)="manageRfidEncodingSchemeObjectGroupsClicked()"><a><em class="fa fa-pencil"></em>
								MANAGE GROUPS</a></li>
					</ul>
				</div>

				<!-- Filter (dropdown + type-aware value input) -->
				<app-filter-bar
					[options]="filterOptionsForTypes"
					[(selected)]="filterOptionForTypes"
					(filterChanged)="onTypesFilterChanged($event)">
				</app-filter-bar>

				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
						<em class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span>
					</button>
					<ul class="dropdown-menu">
						<li *ngFor="let value of resultsPerPageValues" (click)="manageResultsPerPageClickedForTypes(value)" [class.active]="value === selectedPageSizeValueForTypes">
							<a>{{ value }}</a>
						</li>
					</ul>
				</div>

				<!-- Rfid Encoding Scheme Objects -->
				<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table"
					data-id-field="userid" role="grid">
					<thead>
						<tr role="row" class="tablesorter-headerRow">
							<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
								scope="col" role="columnheader" aria-disabled="false" aria-controls="table1"
								aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
								style="user-select: none;">
								<div class="tablesorter-header-inner">
									<input type="checkbox" [checked]="isAllRfidEncodingSchemeObjectsSelected()"
										(change)="setAllRfidEncodingSchemeObjectsSelected($event)" />
								</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
								aria-label="Name: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Name</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="groups" data-sortable="true" data-column="2" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
								aria-label="Groups: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Groups</div>
							</th>
						</tr>
					</thead>
					<tbody aria-live="polite" aria-relevant="all">
						<ng-container
							*ngFor="let rfidEncodingSchemeObject of mRfidEncodingSchemeObjects | paginate: { id: 'encodingscheme_pagination', itemsPerPage: selectedPageSizeValueForTypes, currentPage: currentPageForTypes, totalItems: totalNumberOfTypes }">
							<tr class="" role="row">
								<td><input type="checkbox" [(ngModel)]="rfidEncodingSchemeObject.mSelected" /></td>
								<td (click)="editRfidEncodingScheme(rfidEncodingSchemeObject.mRfidEncodingScheme)">
									{{rfidEncodingSchemeObject.mRfidEncodingScheme.name}}</td>
								<td>
									<ng-container
										*ngIf="rfidEncodingSchemeObject.mRfidEncodingScheme.groups != null && rfidEncodingSchemeObject.mRfidEncodingScheme.groups.length > 0">
										<ng-container
											*ngFor="let group of rfidEncodingSchemeObject.mRfidEncodingScheme.groups">
											<button class="groupButton"
												(click)="showGroup(group)">{{group.name}}</button>
										</ng-container>
									</ng-container>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>

				<!-- Pagination Controls for the "Encoding Scheme" Types (controls referenced in the *ngFor for the table data above) -->
				<pagination-controls class="pagination" id="encodingscheme_pagination"
					(pageChange)="onTypePageChange($event)" [directionLinks]="true" nextLabel="Next"
					previousLabel="Prev" [autoHide]="true">
				</pagination-controls>

			</div>

			<!-- Rfid Encoding Scheme Instances Tab -->
			<div id="rfid-encoding-scheme-instances-tab" class="tab-pane fade active in">

				<!-- "Add Encoding" Button -->
				<button (click)="addRfidEncodingSchemeInstanceClicked()" type="button" class="btn btn-ef"><em
						class="fa fa-plus"></em> ADD ENCODING
				</button>

				<!-- "Options" Button w/ drop down options -->
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-th"></em> OPTIONS <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<li (click)="editSelectedRfidEncodingSchemeInstanceClicked()"
							[class.disabled]="!isSingleRfidEncodingSchemeInstanceSelected()"><a><em
									class="fa fa-pencil"></em> EDIT</a></li>
						<li (click)="duplicateSelectedRfidEncodingSchemeInstanceClicked()"
							[class.disabled]="!isSingleRfidEncodingSchemeInstanceSelected()"><a><em
									class="fa fa-clone"></em> DUPLICATE</a></li>
						<li (click)="deleteSelectedRfidEncodingSchemeInstancesClicked()"
							[class.disabled]="!isAnyRfidEncodingSchemeInstancesSelected()"><a><em
									class="fa fa-remove"></em> DELETE</a></li>
						<li class="divider"></li>
						<li (click)="addSelectedRfidEncodingSchemeInstancesToGroupClicked()"
							[class.disabled]="!isAnyRfidEncodingSchemeInstancesSelected()"><a><em
									class="fa fa-plus"></em> ADD TO GROUP</a></li>
						<li (click)="removeSelectedRfidEncodingSchemeInstancesFromGroupClicked()"
							[class.disabled]="!isAnyRfidEncodingSchemeInstancesSelected()"><a><em
									class="fa fa-remove"></em> REMOVE FROM GROUP</a></li>
						<li (click)="manageRfidEncodingSchemeInstanceGroupsClicked()"><a><em class="fa fa-pencil"></em>
								MANAGE GROUPS</a></li>
					</ul>
				</div>

				<!-- Filter (dropdown + type-aware value input) -->
				<app-filter-bar
					[options]="filterOptionsForInstances"
					[multiple]="true" [(active)]="activeFilterOptionsForInstances"
					(filterChanged)="onInstancesFilterChanged($event)">
				</app-filter-bar>

				<div class="dropdown btn-group edgefinityHeader" style="display: inline-block;">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
						<em class="fa fa-bars"></em> RESULTS PER PAGE<span class="caret"></span>
					</button>
					<ul class="dropdown-menu">
						<li *ngFor="let value of resultsPerPageValues" (click)="manageResultsPerPageClickedForInstances(value)" [class.active]="value === selectedPageSizeValueForInstances">
							<a>{{ value }}</a>
						</li>
					</ul>
				</div>


				<!-- Rfid Encoding Scheme Instances -->
				<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table"
					data-id-field="userid" role="grid">
					<thead>
						<tr role="row" class="tablesorter-headerRow">
							<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
								scope="col" role="columnheader" aria-disabled="false" aria-controls="table2"
								aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
								style="user-select: none;">
								<div class="tablesorter-header-inner">
									<input type="checkbox" [checked]="isAllRfidEncodingSchemeInstancesSelected()"
										(change)="setAllRfidEncodingSchemeInstancesSelected($event)" />
								</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Name: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Name</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="object" data-sortable="true" data-column="2" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Asset Type: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Encoding Type</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="groups" data-sortable="true" data-column="3" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Groups: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Groups</div>
							</th>
						</tr>
					</thead>
					<tbody aria-live="polite" aria-relevant="all">
						<ng-container
							*ngFor="let rfidEncodingSchemeInstance of mRfidEncodingSchemeInstances | paginate: { id: 'encodingschemeinstance_pagination', itemsPerPage: selectedPageSizeValueForInstances, currentPage: currentPageForInstances, totalItems: totalNumberOfInstances }">
							<tr class="" role="row">
								<td><input type="checkbox" [(ngModel)]="rfidEncodingSchemeInstance.mSelected" /></td>
								<td
									(click)="editRfidEncodingSchemeInstance(rfidEncodingSchemeInstance.mRfidEncodingSchemeInstance)"  (contextmenu)="fetchFunctionList($event, rfidEncodingSchemeInstance.mRfidEncodingSchemeInstance)">
									{{rfidEncodingSchemeInstance.mRfidEncodingSchemeInstance.name}}</td>
								<td
									(click)="editRfidEncodingSchemeInstance(rfidEncodingSchemeInstance.mRfidEncodingSchemeInstance)">
									{{rfidEncodingSchemeInstance.mRfidEncodingSchemeInstance.object.name}}</td>
								<td>
									<ng-container
										*ngIf="rfidEncodingSchemeInstance.mRfidEncodingSchemeInstance.groups != null && rfidEncodingSchemeInstance.mRfidEncodingSchemeInstance.groups.length > 0">
										<ng-container
											*ngFor="let group of rfidEncodingSchemeInstance.mRfidEncodingSchemeInstance.groups">
											<button class="groupButton"
												(click)="showGroup(group)">{{group.name}}</button>
										</ng-container>
									</ng-container>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>

				<pagination-controls class="pagination" id="encodingschemeinstance_pagination"
					(pageChange)="onInstancePageChange($event)" [directionLinks]="true"
					nextLabel="Next" previousLabel="Prev" [autoHide]="true">
				</pagination-controls>
			</div>
		</div>
	</div>
</div>

<app-entity-type-dialog #entityTypeDialog [entity]="mEntity" [entityName]="mEntityName" [entityType]="mEntityType"
	[entityTypeName]="mEntityTypeName" (createOrUpdateEvent)="createOrUpdateEntityType()"
	(showGroup)="showGroup($event)">
</app-entity-type-dialog>

<app-entity-instance-dialog #entityInstanceDialog [instance]="mInstance"
	[instanceName]="mInstanceName" [instanceEntityType]="mInstanceEntityType" [instanceType]="mInstanceType"
	[instanceTypeName]="mInstanceTypeName" [availableEntityTypes]="mAvailableEntityTypes"
	(createOrUpdateEvent)="createOrUpdateEntityInstance()" (showGroup)="showGroup($event)"
	(selectedEntityTypeChangedEvent)="selectedEntityTypeChanged($event)"
	(refreshInstanceDataEvent)="refreshInstanceData()">
</app-entity-instance-dialog>

<app-confirm-delete-dialog #confirmDeleteDialog (confirmEvent)="deleteConfirmed()"></app-confirm-delete-dialog>
<app-show-group-dialog #showGroupDialog></app-show-group-dialog>
<app-manage-groups-dialog #manageGroupsDialog></app-manage-groups-dialog>
<app-add-to-group-dialog #addToGroupDialog (confirmEvent)="addSelectedToGroup($event)"></app-add-to-group-dialog>
<app-remove-from-group-dialog #removeFromGroupDialog (confirmEvent)="removeSelectedFromGroup($event)">
</app-remove-from-group-dialog>

<!-- Right Click dropdown menu -->
<app-dropdown-menu *ngIf="showContextMenu" [x]="contextMenuPosition.x" [y]="contextMenuPosition.y"
	[items]="functionList" (selectedItemChange)="onItemClicked($event)"></app-dropdown-menu>

<!-- Going further if we want to display the function execution status
	<app-function-executing-dialog  #functionExecutingDialog (functionExecutionStartEvent)="functionStartingToExecute($event)" (functionExecutionSuccessEvent)="functionFinishedExecutingSuccessfully()" (functionExecutionErrorEvent)="functionFinishedExecutingWithError($event)"></app-function-executing-dialog> -->

<app-general-function-dialog *ngIf="showGeneralDialog" #generalDialog [instance]="mInstance"
	[instanceType]="mInstanceType" [function]="selectedFunction"></app-general-function-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>